<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<!-- <el-col :span="6">
				<el-select clearable style="width: 100%;" v-model="searchInfo.businessID" filterable placeholder="请选择商家">
				    <el-option v-for="item in businessList" :key="item.entry_business_id" :label="item.entry_business_name" :value="item.entry_business_id"> </el-option>
				</el-select>
			</el-col> -->
			<el-col :span="5">
				<el-select clearable style="width: 100%;" v-model="searchInfo.stallID" filterable placeholder="请选择档口">
				    <el-option v-for="item in stallList" :key="item.stall_id" :label="item.stall_name" :value="item.stall_id"> </el-option>
				</el-select>
			</el-col>
			<el-col :span="6"> 
				<el-input clearable placeholder="请输入名称" v-model="searchInfo.realname">
					<template slot="prepend">名称</template>
				</el-input>
			</el-col>
			<el-col :span="6"> 
				<el-input clearable placeholder="请输入电话" v-model="searchInfo.telphone">
					<template slot="prepend">电话</template>
				</el-input>
			</el-col>			
			<el-col :span="7"> 
				<el-button type="primary" @click="searchShopUser" icon="el-icon-search">搜索</el-button>
				<el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				<el-button type="primary" icon="el-icon-plus" @click="addShopUser">新增</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="shopuserList"  style="width: 100%"  height="700">
			    <el-table-column fixed="left" prop="username" label="用户名" width="150" align="center"></el-table-column>
			    <el-table-column prop="realname" label="真实姓名" width="120" align="center"></el-table-column>
			    <el-table-column prop="telphone" label="电话"  width="120" align="center"></el-table-column>
			    <el-table-column prop="expirationdate" label="过期时间" width="120" align="center"></el-table-column>
			    <el-table-column prop="business_name" label="所属商家" align="center"></el-table-column>
				<el-table-column prop="stall_name" label="所属档口" align="center"></el-table-column>				
				<el-table-column prop="statename" label="状态" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goShopUserDetail(scope.$index, scope.row)" title="详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-Stall">详情</i>
						</a>
						<a v-show="scope.row.state == 'stop'" @click="ChangeState(scope.$index, scope.row)" title="启用" style="cursor:pointer;margin-left: 10px;color: #E6A23C;">
							<i class="el-icon-bottom">启用</i>
						</a>
						<a v-show="scope.row.state == 'normal'" @click="ChangeState(scope.$index, scope.row)" title="停用" style="cursor:pointer;margin-left: 10px;color: #67C23A;">
							<i class="el-icon-top">停用</i>
						</a>
						<a v-show="scope.row.state == 'stop'" @click="deleteShopUsers(scope.$index, scope.row)" title="删除商家用户" style="cursor:pointer;margin-left: 10px;color: #F56C6C;">
							<i class="el-icon-delete">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="shopuserTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" width="70%" :visible.sync="detailShow">
			<ShopUserDetail @needRefrash="needRefrash" :select_id="selectID" :businesses="businessList" :stalls="stallList"></ShopUserDetail>
		</el-dialog>
	</div>
</template>

<script>
	import dayjs from 'dayjs'
	import {queryBusinessLists,queryStallLists,queryShopUserLists,ChangeShopUserState,deleteShopUser } from '/static/apiUrl.js'
	import ShopUserDetail from './shopuserdetail'
	export default {
		name : 'shopuserList',
		data() {
			return {
				detailShow: false,
				editok : false,
				detailTitle: '商家用户详情',
				selectID: '',	
				searchInfo:{
					businessID: '',
					stallID: '',
					realname: '',
					telphone : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				businessList: [],
				stallList : [],
				shopuserTotal : 0,
				shopuserList : [],				
			}
		},
		mounted() {
			this.initData()
			this.queryShopUser()
		},
		components: {
			ShopUserDetail,
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryShopUser()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryShopUser()
			},
			ChangeState(idx, row){
				console.log(idx, row)
				let name = ""
				let new_state = ""
				if (row.state == "normal") {
					name = "停用"
					new_state = "stop"
				} else { 
					name = "启用"
					new_state = "normal"
				}
				this.$confirm('确定将 ' + row.username + ' ' + name + '?', name, {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					ChangeShopUserState({
						state: new_state,
						id: row.id
					}).then(res => {
						console.log(res)
						if (0 == res.code) {
							row.statename = name
							row.state = new_state
							this.$message({
								type: 'success',
								message: name + '成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			deleteShopUsers(idx,row){
				console.log(idx,row)
				this.$confirm('确定将 '+row.username+' 删除?', '商家用户删除', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fids = [row.id]
					deleteShopUser({
						ids : fids
					}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.shopuserList.splice(idx,1)
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			initData() {
				queryBusinessLists({
					state: "normal",
					offset: 0,
					limit: 100
				}).then(res => {
					console.log(res)
					if (0 == res.code) {
						this.businessList = res.data.data
					}
				})

				queryStallLists({
					state: "normal",
					offset: 0,
					limit: 100
				}).then(res => {
					console.log(res)
					if (0 == res.code) {
						this.stallList = res.data.data
					}
				})
			},
			searchShopUser(){
				this.param.page = 1
				this.shopuserList = []
				this.queryShopUser()
			},
			clearSearch(){
				this.searchInfo.businessID = ''
				this.searchInfo.stallID = ''
				this.searchInfo.realname = ''
				this.searchInfo.telphone = ''
				this.param.page = 1
				this.queryShopUser()
			},
			queryShopUser(){
				this.shopuserList = []
				queryShopUserLists({
					business_id: this.searchInfo.businessID,
					stall_id : this.searchInfo.stallID,
					name: this.searchInfo.realname,
					telphone : this.searchInfo.telphone,
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.shopuserTotal = res.data.total
						res.data.data.forEach((shopuser) => {
							this.shopuserList.push({
								id : shopuser.shopsuser_id,
								username : shopuser.shopsuser_username,
								realname : shopuser.shopsuser_realname,
								telphone : shopuser.shopsuser_telphone,
								expirationdate: dayjs(shopuser.shopsuser_expirationdate).format('YYYY-MM-DD'),
								stall_name : shopuser.service_stall_name,
								business_name : shopuser.service_business_name,
								state : shopuser.shopsuser_state,
								statename : shopuser.shopsuser_state == 'normal' ? '启用' : '停用',								
							})
						})
					}
				})
			},
			goShopUserDetail(idx,row){
				this.detailTitle = '商家用户详情'
				console.log(idx, row)
				this.selectID = row.id
				this.detailShow = true
			},
			addShopUser(){
				this.detailTitle = "新增商家用户"
				this.selectID = ''
				this.detailShow = true
			},
			needRefrash(val,isshow){
				console.log(val, isshow)
				this.editok = val
				this.detailShow = isshow
			},
			refrashData() {
				console.log('ddd')
				if(this.editok){
					this.queryShopUser()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>